import { useState } from 'react';

import Image from 'next/image';

import { Grid, Box, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { CircularProgressWithLabel } from '@/src/components/atoms';

const useStyles = makeStyles(theme => ({
  imgWrapper: {
    position: 'relative',
    width: 100,
    height: 100,
  },
  logoImg: {
    filter: 'grayscale(100%)',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.complex,
    }),
    '&:hover': {
      filter: 'grayscale(0%)',
    },
  },
}));

export default function Partners({ className, institutions = [], ...rest }) {
  const classes = useStyles();
  const theme = useTheme();

  const [loaded, setLoaded] = useState({});

  const isMd = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={isMd ? 4 : 2} justifyContent="space-between">
        {institutions?.slice(0, 6).map(institution => (
          <Grid item container justifyContent="center" xs={6} sm={2} key={institution.slug}>
            <div className={classes.imgWrapper}>
              {institution.logo && !loaded[institution.slug] && (
                <Box display="flex" height="100%" alignItems="center" justifyContent="center">
                  <CircularProgressWithLabel size={50} />
                </Box>
              )}
              {institution.logo && (
                <Image
                  src={institution.logo}
                  alt={institution.name || institution.slug}
                  className={classes.logoImg}
                  layout="fill"
                  objectFit="contain"
                  quality={60}
                  onLoad={event =>
                    setLoaded(prevState => ({
                      ...prevState,
                      [institution.slug]: event.target.complete,
                    }))
                  }
                />
              )}
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

Partners.propTypes = {
  className: PropTypes.string,
  institutions: PropTypes.array,
};
